import "./ticket-dialog.scss";
import template from "./ticket-dialog.hbs";
import { component, events } from "../../../hiyo/decorators.js";
import { Component } from "../../../hiyo/component.js";
import { TicketDialogOptions } from "./types.js";
import { Context } from "../../../hiyo/context.js";

@component(template)
@events("click", "keyup")
export class TicketDialog extends Component<Context, TicketDialogOptions> {

    public onEvent(event: Event) {
        // Close self on click
        if ((<MouseEvent>event).type == "click") {
            this.remove();
        }

        // Close self on ESC
        if ((<KeyboardEvent>event).code == "Escape") {
            this.remove();
        }
    }
}